
import React from "react";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { Navigate } from "react-router-dom";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUsers from "@/pages/AdminUsers";
import AdminAgents from "@/pages/AdminAgents";
import AdminTransactions from "@/pages/AdminTransactions";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminSettings from "@/pages/AdminSettings";
import AdminFileValidation from "@/pages/AdminFileValidation";

export const AdminRoute = () => {
  const { user } = useAuth();
  
  // If not authenticated or not an admin, redirect to home
  if (!user || !user.isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/users" element={<AdminUsers />} />
      <Route path="/agents" element={<AdminAgents />} />
      <Route path="/transactions" element={<AdminTransactions />} />
      <Route path="/analytics" element={<AdminAnalytics />} />
      <Route path="/settings" element={<AdminSettings />} />
      <Route path="/file-validation" element={<AdminFileValidation />} />
      {/* Default route if none match */}
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};
